import { ForwardRefExoticComponent, RefAttributes, SVGProps } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'

import './index.styles.css'

interface SimpleLabelProps {
  label: string
  icon: ForwardRefExoticComponent<
    Omit<SVGProps<SVGSVGElement>, 'ref'> & RefAttributes<SVGSVGElement>
  >
}

export const SimpleLabel = ({ label, icon }: SimpleLabelProps) => (
  <Box flexDirection="row" gap="s2" alignItems="center" justifyContent="flexEnd">
    <Text.Normal color="grey700" size="100">
      <F0Icon icon={icon} type="warning" />
    </Text.Normal>
    <Text.Normal color="grey700" size="100" className="SyncStateLabel_labelMargin">
      {label}
    </Text.Normal>
  </Box>
)
